import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { CheckListType } from 'projects/Autofacets-Core/src/app/utils/enums';
import { DwoCheckListGroupItemCheckboxMappingViewModel, DwoCheckListGroupItemRadiobuttonMappingViewModel } from '../../../business-entities/dwo-check-list-group-item-checkbox-mapping-view-model';
import { DwoCheckListGroupItemMappingViewModel, EditDwoCheckListGroupItemViewModel } from '../../../business-entities/dwo-check-list-group-item-mapping-view-model';
import { CheckBoxList, CheckboxObjectDetails, CheckListItemByMappingIdModel, RadioBtnList, RadiobuttonObjectDetails } from '../../../business-entities/dwo-check-list-request-model';
import { GenericResponse } from '../../../business-entities/generic-response';
import { CheckListBusinessService } from '../../../business-services/check-list.service';
import * as fromenums from './../../../../../../Autofacets-Core/src/app/utils/enums'

@Component({
  selector: 'app-add-check-list-items',
  templateUrl: './add-check-list-items.component.html',
  styleUrls: ['./add-check-list-items.component.css']
})
export class AddCheckListItemsComponent implements OnInit {
  checkListId: number;
  languageList: any[];
  parentId: number;
  addCheckListItemForm: FormGroup;
  checkListItems: CheckListItemByMappingIdModel
  condition: boolean = false;
  editMode = false
  add: string
  currentUser: string
  subCheckListTitle: string;
  checkboxTitleList: Array<DwoCheckListGroupItemCheckboxMappingViewModel> = [];
  radiobuttonTitleList: Array<DwoCheckListGroupItemRadiobuttonMappingViewModel> = [];
  dwoCheckListGroupItemMappingViewModel: DwoCheckListGroupItemMappingViewModel
  editdwoCheckListGroupItemMappingViewModel: EditDwoCheckListGroupItemViewModel;
  cltype: number = 0;
  checkBox: CheckboxObjectDetails[] = [];
  checkBoxList: any = {
    checkBoxList: []
  };
  radioBtnList: any = {
    radioBtnList: []
  }
  check: CheckBoxList = {
    radioBtnList: []
  }
  radio: RadioBtnList =
    {
      radioBtnList: []
    }
  radioButton: RadiobuttonObjectDetails[] = [];
  isCheckBoxItem:boolean = false;
  isRadioButtonItem:boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public pService: CustomPaggerService,
    private currentLanguageService: CurrentLanguage,
    private toastr: ToastrService,
    private translate: TranslateService,
    private checkListBusinessService: CheckListBusinessService,
    private activeModal : NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.languageList = this.currentLanguageService.LanguageList;
    this.checkListBusinessService.isEdit = true;
    this.parentId = this.checkListBusinessService.checkListItemId;
    this.addCheckListItemForm = this.formBuilder.group({
      service: new FormArray([]),
      sequence: ['', [Validators.required,Validators.min(1), Validators.max(99)]],
      camaraAvailable: [false],
      textBox: [false],
      checkBox: [false],
      radioButton: [false],
      isQuestionActive: [false],
      checkbox: new FormArray([]),
      csequence: [''],
      radio: new FormArray([]),
      rsequence: [''],
      photoGraphyDetails: ['']
    })
    this.subCheckListTitle = this.checkListBusinessService.check;
    this.add = this.checkListBusinessService.IsAddItems
    this.getLanguage();
    this.checkListId = this.checkListBusinessService.checkListItemId;
    if (this.add === '0') {
      this.editMode = true;
      this.condition = true;
      this.getCheckListItemsByMappingId(this.checkListId)
    }

  }
  get t() { return this.cpf.service as FormArray; }
  get c() { return this.cpf.checkbox as FormArray; }
  get r() { return this.cpf.radio as FormArray; }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['',],
          name: ['', [Validators.required]],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }



    if (this.c.length < number) {
      for (let i = this.c.length; i < number; i++) {
        this.c.push(this.formBuilder.group({
          languageId: ['',],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.c.length; i >= number; i--) {
        this.c.removeAt(i);
      }
    }



    if (this.r.length < number) {
      for (let i = this.r.length; i < number; i++) {
        this.r.push(this.formBuilder.group({
          languageId: ['',],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.r.length; i >= number; i--) {
        this.r.removeAt(i);
      }
    }
  }

  OnClose(){
    this.activeModal.close({success:false})
  }
  get cpf() {
    return this.addCheckListItemForm.controls;
  }
  getCheckListItemsByMappingId(id: number) {
    this.spinner.show();
    this.checkBox = [];
    this.checkListBusinessService.getCheckListItemsByMappingId(id).then((response: GenericResponse<any>) => {
      if (response.responseCode === 200 && response.responseObject.errorCount === undefined) {
        this.checkListItems = response.responseObject;
        if (this.checkListItems) {
          if (this.checkListItems.checkListItemDetail && this.checkListItems.checkListItemDetail.length > 0) {
            this.addCheckListItemForm.patchValue({ service: this.checkListItems.checkListItemDetail })
          }
          if (this.checkListItems.checkListDetail && this.checkListItems.checkListDetail.length > 0) {
            this.addCheckListItemForm.patchValue({
              sequence: this.checkListItems.checkListDetail[0].sequence,
              camaraAvailable: this.checkListItems.checkListDetail[0].camaraAvailable,
              isQuestionActive: this.checkListItems.checkListDetail[0].isQuestionActive,
              photoGraphyDetails: this.checkListItems.checkListDetail[0].photoGraphyDetails,
            })
            if (this.checkListItems.checkListDetail[0].checkListType === CheckListType.TYPE_3_CHECKBOX_TEXTBOX) {
              this.addCheckListItemForm.patchValue({ "textBox": true, "checkBox": true });
            }
            if (this.checkListItems.checkListDetail[0].checkListType === CheckListType.TYPE_1_CHECKBOX) {
              this.addCheckListItemForm.patchValue({ "checkBox": true });
            }
            if (this.checkListItems.checkListDetail[0].checkListType === CheckListType.TYPE_2_TEXTBOX) {
              this.addCheckListItemForm.patchValue({ "textBox": true });
            }
            if (this.checkListItems.checkListDetail[0].checkListType === CheckListType.TYPE_4_RADIOBUTTON) {
              this.addCheckListItemForm.patchValue({ "radioButton": true });
            }
            if (this.checkListItems.checkListDetail[0].checkListType === CheckListType.TYPE_5_RADIOBUTTON_TEXTBOX) {
              this.addCheckListItemForm.patchValue({ "radioButton": true, "textBox": true });
            }
            if (this.checkListItems.checkListDetail[0].checkListType === CheckListType.TYPE_6_RADIOBUTTON_CHECKBOX) {
              this.addCheckListItemForm.patchValue({ "radioButton": true, "checkBox": true });
            }
            if (this.checkListItems.checkListDetail[0].checkListType === CheckListType.TYPE_7_RADIOBUTTON_CHECKBOX_TEXTBOX) {
              this.addCheckListItemForm.patchValue({ "textBox": true, "checkBox": true, "radioButton": true });
            }
          }
          if (this.checkListItems.checkListCheckBox && this.checkListItems.checkListCheckBox.length > 0) {
            this.checkBox = this.checkListItems.checkListCheckBox
            if (this.checkBox && this.checkBox.length > 0) {
              const check = this.groupBy(this.checkBox, c => c.id)
              if (check) {
                check.forEach(element => {
                  this.checkBoxList.checkBoxList.push(element)
                });
                this.isCheckBoxItem = this.checkBoxList.checkBoxList.some((item)=>{
                  return item[0].isDeleted === false;
                })
              }
            }
          }
          if (this.checkListItems.checkListRadioButton && this.checkListItems.checkListRadioButton.length > 0) {
            this.radioButton = this.checkListItems.checkListRadioButton
            if (this.radioButton && this.radioButton.length > 0) {
              const radio = this.groupBy(this.radioButton, c => c.id)
              if (radio) {
                radio.forEach(element => {
                  this.radioBtnList.radioBtnList.push(element)
                });
                this.isRadioButtonItem = this.radioBtnList.radioBtnList.some((item)=>{
                  return item[0].isDeleted === false;
                })
              }
            }
          }
        }
      }
      this.spinner.hide();
    });
  }
  onSubmit() {
    const number = this.currentLanguageService.LanguageList.length;
    if(this.addCheckListItemForm?.value){
      if(this.addCheckListItemForm.value.service && this.addCheckListItemForm.value.service.length === number && this.addCheckListItemForm.value.sequence?.toString().trim()){
        let title = this.addCheckListItemForm.value.service.map(x=>
          {
            if(!x.name?.trim()){
              return x;
            }
          });
        if(title && title.length > 0){
        let validTitle = title.filter(x=> x !== undefined)
        if(validTitle && validTitle.length > 0)
        {
          let msg = this.translate.instant("lblPleaseEnterValidValue");
          this.toastr.error(msg)
        }
        else{
          this.CheckListItem()
        }
        }
        else{
          this.CheckListItem()
        }
      }
      else{
        let msg = this.translate.instant("lblPleaseEnterValidValue");
        this.toastr.error(msg)
      }
    }

  }
  CheckListItem(){
   if (this.editMode) {
      this.onEdit();

    }
    else {
      this.currentUser = '';
      if (this.addCheckListItemForm.value.checkBox && this.addCheckListItemForm.value.textBox && this.addCheckListItemForm.value.radioButton) {
        this.cltype = 7
      }
      else if (this.addCheckListItemForm.value.textBox && this.addCheckListItemForm.value.checkBox) {
        this.cltype = 3
      }
      else if (this.addCheckListItemForm.value.radioButton && this.addCheckListItemForm.value.checkBox) {
        this.cltype = 6
      }
      else if (this.addCheckListItemForm.value.radioButton && this.addCheckListItemForm.value.textBox) {
        this.cltype = 5
      }
      else if (this.addCheckListItemForm.value.textBox) {
        this.cltype = 2
      }
      else if (this.addCheckListItemForm.value.checkBox) {
        this.cltype = 1
      }
      else if (this.addCheckListItemForm.value.radioButton) {
        this.cltype = 4
      }

      this.dwoCheckListGroupItemMappingViewModel = {
        id: 0,
        parentId: this.parentId,
        clType: fromenums.ClType.Generic,
        userId: this.currentUser,
        sequence: Number(this.addCheckListItemForm.value.sequence),
        checkListGroupItemViewModel: {
          id: 0,
          mappingId: 0,
          makeCameraAvailable: this.addCheckListItemForm.value.camaraAvailable,
          isQuestionActive: this.addCheckListItemForm.value.isQuestionActive,
          checkListType: this.cltype
        },
        checkListGroupItemDetailsViewModel: [
          {
            id: 0,
            mappingId: 0,
            subCheckListItemTitleDetails: this.addCheckListItemForm.value.service,
            photoGraphyDetails: this.addCheckListItemForm.value.photoGraphyDetails,
            sequence: Number(this.addCheckListItemForm.value.sequence)
          }
        ],
        checkListGroupItemCheckboxMappingViewModel: this.checkboxTitleList.length > 0 && this.addCheckListItemForm.value.checkBox ? this.checkboxTitleList : [],
        checkListGroupItemRadiobuttonMappingViewModel: this.radiobuttonTitleList.length > 0 && this.addCheckListItemForm.value.radioButton ? this.radiobuttonTitleList : []
      }
      this.spinner.show();
      this.checkListBusinessService.addCheckListItem(this.dwoCheckListGroupItemMappingViewModel).then((_response: GenericResponse<any>) => {
        let successMsg = this.translate.instant("lblCheckListItemAdded");
        this.toastr.success(successMsg);
        this.activeModal.close({ success: true
        });
        this.spinner.hide();
      });
    }

  }


  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }
  onEdit() {
    this.currentUser = '';
    if (this.addCheckListItemForm.value.radioButton && this.addCheckListItemForm.value.textBox && this.addCheckListItemForm.value.checkBox) {
      this.cltype = 7
    }
    else if (this.addCheckListItemForm.value.textBox && this.addCheckListItemForm.value.checkBox) {
      this.cltype = 3
    }
    else if (this.addCheckListItemForm.value.radioButton && this.addCheckListItemForm.value.textBox) {
      this.cltype = 5
    }
    else if (this.addCheckListItemForm.value.radioButton && this.addCheckListItemForm.value.checkBox) {
      this.cltype = 6
    }
    else if (this.addCheckListItemForm.value.textBox) {
      this.cltype = 2
    }
    else if (this.addCheckListItemForm.value.checkBox) {
      this.cltype = 1
    }
    else if (this.addCheckListItemForm.value.radioButton) {
      this.cltype = 4
    }
    this.check.radioBtnList = this.checkBoxList.checkBoxList
    this.radio.radioBtnList = this.radioBtnList.radioBtnList
    this.editdwoCheckListGroupItemMappingViewModel = {
      id: 0,
      parentId: this.parentId,
      clType: fromenums.ClType.Generic,
      userId: this.currentUser,
      sequence: Number(this.addCheckListItemForm.value.sequence),
      checkListGroupItemViewModel: {
        id: 0,
        mappingId: this.parentId,
        makeCameraAvailable: this.addCheckListItemForm.value.camaraAvailable,
        isQuestionActive: this.addCheckListItemForm.value.isQuestionActive,
        checkListType: this.cltype
      },
      checkListGroupItemDetailsViewModel: [
        {
          id: 0,
          mappingId: this.parentId,
          subCheckListItemTitleDetails: this.addCheckListItemForm.value.service,
          photoGraphyDetails: this.addCheckListItemForm.value.photoGraphyDetails,
          sequence: Number(this.addCheckListItemForm.value.sequence)
        }
      ],

      checkListGroupItemCheckboxMappingViewModel: this.checkBoxList.checkBoxList.length > 0 ? this.check : null,
      checkListGroupItemRadiobuttonMappingViewModel: this.radioBtnList.radioBtnList.length > 0  ? this.radio : null
    }
    this.spinner.show();
    this.checkListBusinessService.updateCheckListItems(this.editdwoCheckListGroupItemMappingViewModel).then((_response: GenericResponse<any>) => {
      let successMsg = this.translate.instant("lblCheckListItemUpdated");
      this.toastr.success(successMsg);
      this.activeModal.close({ success: true
      });
      this.spinner.hide();
    });
  }

  addCheckBox() {
    if (this.editMode) {
      let checkListArrayItem:Array<CheckboxObjectDetails> = [];
      this.addCheckListItemForm.value.checkbox.forEach(element => {
        let Obj:CheckboxObjectDetails = {
          languageId:element.languageId,
          name:element.name,
          isDeleted:false,
          id:0,
          sequence:0
        }
        checkListArrayItem.push(Obj)
      });
      this.checkBoxList.checkBoxList.push(checkListArrayItem);
      this.isCheckBoxItem = this.checkBoxList.checkBoxList.some((item)=>{
        return item[0].isDeleted === false;
      })      
    }
    else {
      this.checkboxTitleList.push({
        id: this.checkboxTitleList.length > 0 ? this.checkboxTitleList[this.checkboxTitleList.length - 1].id + 1 : 1,
        parentId: 0,
        isDeleted: false,
        checkListGroupItemCheckboxDetailsViewModel: [
          {
            id: 0,
            mappingId: 0,
            checkboxTitle: this.addCheckListItemForm.value.checkbox,
            sequence: Number(this.addCheckListItemForm.value.csequence)
          }
        ]
      });
    }
    this.addCheckListItemForm.patchValue({ csequence: '' });
    this.c.controls.forEach(group => group.get('name').reset())
  }
  deleteCheckBox(id) {
    this.checkboxTitleList = this.checkboxTitleList.filter(x => x.id != id);
    if (this.checkboxTitleList && this.checkboxTitleList.length <= 0) {
      this.addCheckListItemForm.patchValue({ checkBox: false });
    }
  }
  deleteCheckBoxInEditMode(index: number) {
    this.checkBoxList.checkBoxList[index].forEach((x) => {
      x.isDeleted = true;
    })
    this.isCheckBoxItem = this.checkBoxList.checkBoxList.some((item)=>{
      return item[0].isDeleted === false;
    })
    if (!this.isCheckBoxItem) {
      this.addCheckListItemForm.patchValue({ checkBox: false });
    }
  }

  addRadioButton() {
    if (this.editMode) {
      let radioListArrayItem:Array<RadiobuttonObjectDetails> = [];
      this.addCheckListItemForm.value.radio.forEach(element => {
        let Obj:RadiobuttonObjectDetails = {
          languageId:element.languageId,
          name:element.name,
          isDeleted:false,
          id:0,
          sequence:0
        }
        radioListArrayItem.push(Obj)
      });
      this.radioBtnList.radioBtnList.push(radioListArrayItem);
      this.isRadioButtonItem = this.radioBtnList.radioBtnList.some((item)=>{
        return item[0].isDeleted === false;
      })
    }
    else {
      this.radiobuttonTitleList.push({
        id: this.radiobuttonTitleList.length > 0 ? this.radiobuttonTitleList[this.radiobuttonTitleList.length - 1].id + 1 : 1,
        parentId: 0,
        isDeleted: false,
        checkListGroupItemRadiobuttonDetailsViewModel: [
          {
            id: 0,
            mappingId: 0,
            radioTitle: this.addCheckListItemForm.value.radio,
            sequence: Number(this.addCheckListItemForm.value.rsequence)
          },
        ]
      });
    }
    this.addCheckListItemForm.patchValue({ rsequence: '' });
    this.r.controls.forEach(group => group.get('name').reset())
  }
  deleteRadioButton(id) {
    this.radiobuttonTitleList = this.radiobuttonTitleList.filter(x => x.id != id);
    if (this.radiobuttonTitleList && this.radiobuttonTitleList.length <= 0) {
      this.addCheckListItemForm.patchValue({ radioButton: false });
    }
  }
  deleteRadioButtonInEditMode(index: number) {
    this.radioBtnList.radioBtnList[index].forEach((x) => {
      x.isDeleted = true;
    })
    this.isRadioButtonItem = this.radioBtnList.radioBtnList.some((item)=>{
      return item[0].isDeleted === false;
    })
    if (!this.isRadioButtonItem) {
      this.addCheckListItemForm.patchValue({ radioButton: false });
    }
  }
}
